import { convertUTCToLocal } from "@/utility/dateHelper";

export const GetFormattedInventory = (apiResponse = {}) => {
    const {
        data,
        totalRecords = '',
        totalPages = '',
        pageSize = '',
        currentPage = '',
        activeCount = '',

    } = apiResponse;

    const formattedInventory = data?.map(GetInventory);
    return {
        data: formattedInventory,
        totalRecords,
        totalPages,
        pageSize,
        currentPage,
        activeCount,
    };
};

// Helper function to map individual items
const GetInventory = (item = {}) => {
    const {
        productId = 0,
        warehouseId = 0,
        productCategory = "",
        gtin = "",
        stock = "",
        daysOnStock = 0,
        modificationDate,
    } = item;

    return {
        productId,
        warehouseId,
        productCategory,
        gtin,
        stock,
        daysOnStock,
        modificationDate: convertUTCToLocal(modificationDate),
    };
};
